// extracted by mini-css-extract-plugin
export default {"button":"DeleteButton_button__uVxRH"};